import React, { useState } from "react";
import { Button } from "reactstrap";
import Playersimage from "../../../../assets/images/OCH/player.png";
import Tickmark from "../../../../assets/images/dw20/icons/tickmark.png";
import Graph from "../../../../assets/images/dw20/icons/graph.png";
import XIcon from "../../../../assets/images/CHPT/X.png";
import { compose } from "redux";
import { withSocket } from "../../../../socket/context";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import ReactHtmlParser from "react-html-parser";
import { removeUser } from "../../../../components/shared/utils";
import { fadeVariants } from "../../../../components/shared/utils/animations";

const Players = (props) => {
  let gameReducer = _.get(props, "gameReducer");
  let roomData = _.get(gameReducer, "roomObj");
  let played_cards = _.get(roomData, "game_state.played_cards");
  let status = _.get(roomData, "game_state.status");
  let users = _.get(roomData, "users");
  let active_player = _.get(roomData, "game_state.active_player");
  let playerhand = _.get(roomData, "game_state.player_hands");
  let gameData = _.get(props, "paramsReducer.gameObj.screens");
  let show_all = _.get(gameData, "chpt.show_all_players") || "Show all players";
  let show_less = _.get(gameData, "chpt.show_less") || "Show LESS";
  let emoji = "";

  if (gameReducer.emoji !== undefined && gameReducer.emoji !== "") {
    emoji = `<p>&#x${gameReducer.emoji.emoji};</p>`;
  }

  const [showAllUser, setShowAllUser] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const showAllPlayer = () => {
    // if (users && users.length > 3) {
    // }
    setShowAllUser(true);
    setIsOpen((prevState) => {
      return !prevState;
    });
  };
  const hideAllPlayer = () => {
    setShowAllUser(false);
    setIsOpen((prevState) => {
      return !prevState;
    });
  };
  // top 3 players shown are sorted by score (highest to lowest) and then by player id (lowest to highest).
  const sortUsersByScore = (users) => {
    users.sort((user1, user2) => {
      if (user1.score > user2.score) {
        return -1;
      } else if (user1.score < user2.score) {
        return 1;
      } else {
        if (user1.player_id < user2.player_id) {
          return -1;
        } else if (user1.player_id > user2.player_id) {
          return 1;
        } else {
          return 0;
        }
      }
    });
  };
  /**
   * returns true if user has played the card else returns false
   * used to display the  green tick below user's image
   */
  const hasUserPlayed = (user, played_cards) => {
    for (let card of played_cards) {
      if (card.player_id === user.player_id) {
        return true;
      }
    }
    return false;
  };
  /**
   * returns true if user is the card czar else returns false
   * used to display the  green tick below user's image
   */
  const isUserCardCzar = (user, active_player) => {
    return user.player_id === active_player;
  };
  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };
  return (
    <>
      <div className="players-card-container">
        {showAllUser ? (
          <div
            className={`show-all-player-slide ${
              isOpen === true ? "visible" : ""
            }`}
          >
            <div className="d-flex flex-column justify-content-between all-players">
              <h2>All Players</h2>
              <div className="d-flex all-players-wrapper">
                {playerhand &&
                  playerhand.length > 0 &&
                  playerhand.map(
                    (card) =>
                      users &&
                      users.length > 0 &&
                      users.map((user) => {
                        if (user.player_id === card.player_id) {
                          return (
                            <div
                              className={`all-players-box${
                                isUserCardCzar(user, active_player)
                                  ? " card-czar"
                                  : ""
                              }`}
                            >
                              <div className="players-image-wrap">
                                <div className="profile-image">
                                  <img src={user.profile_image} />
                                  {gameReducer.emoji &&
                                    user.user_id ===
                                      gameReducer?.emoji?.userId && (
                                      <motion.div
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, x: "100%" }}
                                      >
                                        {ReactHtmlParser(emoji)}
                                      </motion.div>
                                    )}
                                  {hasUserPlayed(user, played_cards) && (
                                    <Button
                                      color="charityThemeOrange"
                                      className="tick-btn"
                                    >
                                      <img src={Tickmark} alt="tick"></img>
                                    </Button>
                                  )}
                                </div>
                                <Button
                                  className="x-btn"
                                  onClick={() => delPlayer(user)}
                                >
                                  {/* X */}
                                  <span className="cross-icon">X</span>
                                </Button>
                                <Button
                                  color="charityThemeOrange"
                                  className="count"
                                >
                                  {/* {card.score} */}
                                  <span className="card-score">
                                    {card.score}
                                  </span>
                                </Button>
                                <p className="mb-0">{user.display_name}</p>
                              </div>
                            </div>
                          );
                        }
                      })
                  )}
              </div>
            </div>
            <button className="return-btn" onClick={() => hideAllPlayer()}>
              Return to Game
            </button>
          </div>
        ) : (
          <div
            className={` charity-players-wrapper ${
              status === "Reading" ? "charity-players-reading" : ""
            }`}
          >
            {sortUsersByScore(playerhand)}
            {playerhand &&
              playerhand.length > 0 &&
              playerhand.slice(0, 3).map((card) => {
                return (
                  users &&
                  users.length > 0 &&
                  users.map((user) => {
                    if (user.player_id === card.player_id) {
                      return (
                        <div className="charity-player-box-wrapper">
                          <div
                            className={`charity-player-box${
                              isUserCardCzar(user, active_player)
                                ? " card-czar"
                                : ""
                            }`}
                          >
                            <div className="players-img">
                              <img src={user.profile_image} />
                              {/* <div className="emoji">
                                <p>&#x1F622;</p>
                              </div> */}
                              {gameReducer.emoji &&
                                user.user_id === gameReducer.emoji.userId && (
                                  <div className="emoji">
                                    {ReactHtmlParser(emoji)}
                                  </div>
                                )}
                              {hasUserPlayed(user, played_cards) && (
                                <Button
                                  color="charityThemeOrange"
                                  className="tick-btn"
                                >
                                  <img src={Tickmark} alt="tick"></img>
                                </Button>
                              )}
                              {isUserCardCzar(user, active_player) && (
                                <Button
                                  color="charityThemeOrange"
                                  className="graph-btn"
                                >
                                  <img src={Graph} alt="graph"></img>
                                </Button>
                              )}
                              {/* <Button
                                color="charityThemeOrange"
                                className="count"
                              >
                                {card.score}
                              </Button> */}
                              <div className="count-div">
                                <p>{card.score}</p>
                              </div>
                              <p>
                                {user.display_name.length > 15
                                  ? user.display_name.slice(0, 15) + "..."
                                  : user.display_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                );
              })}
          </div>
        )}
        <div className="text-center">
          {showAllUser ? (
            <></>
          ) : (
            // <button className="show-btn" onClick={() => hideAllPlayer()}>
            //   {show_less}
            // </button>
            <>
              {status !== "Reading" && (
                <button className="show-btn" onClick={() => showAllPlayer()}>
                  {show_all}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(Players);
